module.exports = __webpack_public_path__ + "img/twitter.15fa0299.svg";